<template>
  <div>
    <PurchaseDetailComponent />
  </div>
</template>

<script>
import PurchaseDetailComponent from '@/components/Purchase/Detail/index'

export default {
  name: 'purhcase.detail',
  components: { PurchaseDetailComponent },
  methods: {
    fetchOrder () {
      this.$store.dispatch('purchase/GETPURCHASEDETAIL', {
        order_number: this.$route.params.order_id,
      })
    },
  },
  created: function () {
    this.fetchOrder()
  },
}
</script>
